module.exports = __webpack_public_path__ + "static/img/new_circle.3c8271ae.gif";